import axios from 'axios'

const apiBase = process.env.VUE_APP_API_URL || ''
const base = `${apiBase}/api/websites`

const get   = (path, params) => axios.get(`${base}${path}`, { params }).then(r => r.data)
const post  = (path, body)   => axios.post(`${base}${path}`, body).then(r => r.data)
const put   = (path, body)   => axios.put(`${base}${path}`, body).then(r => r.data)
const patch = (path, body)   => axios.patch(`${base}${path}`, body).then(r => r.data)
const del   = (path)         => axios.delete(`${base}${path}`).then(r => r.data)

export const websitesApi = {
  counts:        ()        => get('/counts'),

  productsList:  (params)        => get('/product', params),
  productGet:    (id, source)    => get(`/product/${id}`, source ? { source } : undefined),
  productCreate: (body)          => post('/product', body),
  productUpdate: (id, b)         => put(`/product/${id}`, b),
  productDelete: (id, source)    => axios.delete(`${base}/product/${id}`, { params: source ? { source } : undefined }).then(r => r.data),

  articlesList:  ()        => get('/articles'),
  articleGet:    (id)      => get(`/articles/${id}`),
  articleBySlug: (slug)    => get(`/articles/slug/${slug}`),
  articleCreate: (b)       => post('/articles', b),
  articleUpdate: (id, b)   => put(`/articles/${id}`, b),
  articleDelete: (id)      => del(`/articles/${id}`),

  newsList:      ()        => get('/news'),
  newsGet:       (id)      => get(`/news/${id}`),
  newsCreate:    (b)       => post('/news', b),
  newsUpdate:    (id, b)   => put(`/news/${id}`, b),
  newsDelete:    (id)      => del(`/news/${id}`),

  divisionsList:    ()              => get('/divisions'),
  divisionGet:      (id)            => get(`/divisions/${id}`),
  divisionCreate:   (b)             => post('/divisions', b),
  divisionUpdate:   (id, b)         => put(`/divisions/${id}`, b),
  divisionDelete:   (id)            => del(`/divisions/${id}`),
  branchCreate:     (divId, b)      => post(`/divisions/${divId}/branches`, b),
  branchUpdate:     (divId, bId, b) => put(`/divisions/${divId}/branches/${bId}`, b),
  branchDelete:     (divId, bId)    => del(`/divisions/${divId}/branches/${bId}`),

  doctorsList:   ()        => get('/doctors'),
  doctorGet:     (id)      => get(`/doctors/${id}`),
  doctorCreate:  (b)       => post('/doctors', b),
  doctorUpdate:  (id, b)   => put(`/doctors/${id}`, b),
  doctorPatch:   (id, b)   => patch(`/doctors/${id}`, b),
  doctorDelete:  (id)      => del(`/doctors/${id}`),

  videosList:    ()        => get('/videos'),
  videoGet:      (id)      => get(`/videos/${id}`),
  videoCreate:   (b)       => post('/videos', b),
  videoUpdate:   (id, b)   => put(`/videos/${id}`, b),
  videoDelete:   (id)      => del(`/videos/${id}`),

  timelineList:  ()        => get('/timeline'),
  timelineGet:   (id)      => get(`/timeline/${id}`),
  timelineCreate:(b)       => post('/timeline', b),
  timelineUpdate:(id, b)   => put(`/timeline/${id}`, b),
  timelineDelete:(id)      => del(`/timeline/${id}`),

  categoriesList: (params) => get('/categories', params),

  uploadImage: (file, folder) => {
    const fd = new FormData()
    fd.append('file', file)
    if (folder) fd.append('folder', folder)
    return axios.post(`${base}/upload/image`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data)
  },
}

export default websitesApi
